import { render } from "./PreviewReceipt.vue?vue&type=template&id=7a7b6394&scoped=true&ts=true"
import script from "./PreviewReceipt.vue?vue&type=script&lang=ts"
export * from "./PreviewReceipt.vue?vue&type=script&lang=ts"

import "./PreviewReceipt.vue?vue&type=style&index=0&id=7a7b6394&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7b6394"]])

export default __exports__